
  import {Component, Vue, Prop} from "vue-property-decorator";
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
  import {IBalance} from "@/modules/Payment/interfaces/balance.interface";
  import {httpResource} from "@/resources/http.resource";

  @Component({})
  export default class PayCell extends Vue {
    @Prop() cell: IReport.ITableProp;
    @Prop() entity: IReport.ReportEntityType;
    @Prop() availableReturn!: boolean;

    payTypeIcons = IMovementsReport.PayTypeIcons;

    get value() { return this.entity[this.cell.prop]; }
    get printedValue() {
      return this.value === 0 && !this.entity.finalScore
        ? ''
        : this.$options.filters.currency(this.value, '₽');
    }

    async returnTransaction(item: IMovementsReport.ICarPopupTableItem) {
      let text = 'Сделать возврат денег клиенту?';
      let asyncAction = async () => {
        const action = IBalance.ACTION_PAY;
        const params: any = {
          command: IBalance.Command.ReversalMsg,
          movId: item.movId,
        };
        let response = await httpResource.httpAction({ action, params });
        text = response.data.result.msgText;
      };
      let response = await this.$store.dispatch('defaultResourceAction', { asyncAction });
      if (!response.success) return;

      this.$store.commit('car/setProperty', { name: 'displayContent', value: false });
      await this.$store.dispatch('confirm/open', {
        title: 'Подтверждение операции',
        text,
        cancel: {
          text: 'Отменить',
          action: () => this.$store.commit('car/setProperty', { name: 'displayContent', value: true }),
        },
        confirm: {
          text: 'Подтвердить',
          action: async () => {
            await this.returnTransactionRequest(item);
          },
        },
      });
    }

    async returnTransactionRequest(item: IMovementsReport.ICarPopupTableItem) {
      let asyncAction = async () => {
        const action = IBalance.ACTION_PAY;
        const params: any = {
          command: IBalance.Command.Reversal,
          movId: item.movId,
        };
        return await httpResource.httpAction({ action, params });
      };
      const response = await this.$store.dispatch('defaultResourceAction', {
        asyncAction,
        errorAction: (error) => {
          this.$notify({title: 'Ошибка', message: error.message, type: 'error'});
          this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
        }
      });
      if (response.success) {
        const request = response.response.data.result;
        await this.$store.dispatch('confirm/open', {
          title: request.errorCode ? 'Ошибка' : 'Успешно',
          text: request.errorMessage,
          cancel: {
            text: 'Закрыть',
            action: () => {
              this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
            },
          },
          confirm: {
            text: '',
          }
        });
      }
    }
  }
